import { render, staticRenderFns } from "./export-locations-tab.vue?vue&type=template&id=5999f21f"
import script from "./export-locations-tab.vue?vue&type=script&lang=js"
export * from "./export-locations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports